<template>
  <div id="avatar-startup">
    <img class="avatar" src="../../assets/avatars/avatars-01.svg" />
  </div>
</template>

<script>
export default {
  name: "LoginOverlayAvatar",
  methods: {
    onLoginClick() {
      this.$emit("login");
    },
  },
};
</script>

<style scoped lang="scss">
#avatar-startup {
  .avatar {
    width: 140px;
    height: 140px;
  }
}
</style>
